import { useNavigation, useRoute } from '@react-navigation/native';
import { StackNavigationProp, StackScreenProps } from '@react-navigation/stack';
import { BaseText, Button, Title } from 'aimo-ui';
import CloseButton from 'components/common/CloseButton';
import SafeAreaHeaderContainer from 'navigation/SafeAreaHeaderContainer';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ColumnWithMargins,
  StyledImage,
  StyledWrapper,
} from 'styles/ContainerStyles';
import { FooterWrapper } from 'styles/ModalStackContainerStyles';
import { LongTermStackParamList, RootStackParamList } from 'types/navigation';
import { testIdentifiers } from '../../utils/testIdentifiers';

const CompletedScreen = () => {
  const { t } = useTranslation();
  const { replace } = useNavigation<StackNavigationProp<RootStackParamList>>();
  const handleCompleted = () => {
    replace('permits', {});
  };
  const { orderStatus } =
    useRoute<StackScreenProps<LongTermStackParamList, 'completed'>['route']>()
      .params ?? {};
  const waitingForCSR = orderStatus === 'WAITING_FOR_CSR_APPROVAL';
  return (
    <>
      <StyledWrapper center maxWidth={500} mb={10}>
        <SafeAreaHeaderContainer
          rightContent={
            <ColumnWithMargins mr={20}>
              <CloseButton
                testID="long-term-parking-complete-close-button"
                onPress={handleCompleted}
                buttonType="secondary"
              />
            </ColumnWithMargins>
          }
        />
        <StyledImage
          testID="longTermParking-complete-image"
          width={206}
          height={206}
          center
          source={require('assets/images/onboarding-complete.png')}
        />
      </StyledWrapper>
      <StyledWrapper maxWidth={350} center mb={30}>
        <Title center {...testIdentifiers('long-term-parking-complete-title')}>
          {t('longTermParking.complete.thankYou')}
        </Title>
      </StyledWrapper>
      <StyledWrapper maxWidth={350} center mb={10}>
        <BaseText
          center
          {...testIdentifiers('long-term-parking-complete-description')}>
          {t(
            `longTermParking.complete.${waitingForCSR ? 'completedWaiting' : 'completedText'}`
          )}
        </BaseText>
      </StyledWrapper>
      <FooterWrapper>
        <StyledWrapper center maxWidth={300} mb={0}>
          <Button
            {...testIdentifiers('long-term-parking-complete-button')}
            text={t('button.done')}
            size="l"
            buttonType="secondary"
            onPress={handleCompleted}
          />
        </StyledWrapper>
      </FooterWrapper>
    </>
  );
};

export default CompletedScreen;
